import { AnimatePresence, motion } from 'framer-motion'
import { useStats } from '../lib/ctx/stats'
import { css, cx } from '@fable/theme'
import { statsColors } from '../lib/theme'
import { getBackgroundGradient } from '../lib/utils'

interface Props {
  className?: string
}

export const StatsBackground = ({ className = '' }: Props) => {
  const theme = useStats((s) => s.theme)

  const motionProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.6, ease: 'easeInOut' },
  }

  const styles = cx(
    css`
      display: block;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
    `,
    className
  )

  return (
    <AnimatePresence>
      <motion.div
        key={theme.key}
        data-testid={`stats-theme-${theme.key}`}
        {...motionProps}
        className={cx(
          css`
            background-color: ${statsColors[theme.key].bg};
          `,
          styles
        )}
      >
        <Gradient image={getBackgroundGradient(theme.key)} />
      </motion.div>
    </AnimatePresence>
  )
}

const Gradient = ({ image }: { image: string }) => (
  <span
    style={{ backgroundImage: `url(${image})` }}
    className={css`
      display: block;
      width: 100%;
      aspect-ratio: 9/16;
      background-size: cover;
      background-position: top;
      background-repeat: no-repeat;
    `}
  />
)
